import React from 'react';
import styled from 'styled-components';
import { TermsAndConditionsIFrame } from './TermsAndConditionsIframe';
import { Modal, Container, CloseBtn } from '../../../styles';

class TermsAndConditionsModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            wrapperRef: React.createRef()
        }
        this.handleEvents = this.handleEvents.bind(this);
    }
    componentDidMount(){
        window.addEventListener("mousedown", this.handleEvents);
        window.addEventListener("keydown", this.handleEvents);
    }
    componentWillUnmount(){
        window.removeEventListener("mousedown", this.handleEvents);
        window.removeEventListener("keydown", this.handleEvents);
    }
    handleEvents(event) {
        if (event.key === 'Escape') {
            this.props.handleClick();
        } else if (event.type === 'mousedown') {
            if (!this.node.contains(event.target)) {
                this.props.handleClick();
            }
        }
    }
    render(){
        return(
            <Modal>
              <Container ref={node => this.node = node}>
                <TermsAndConditionsIFrame link={this.props.link}/>
                <CloseBtn onClick={this.props.handleClick}>Close</CloseBtn>
              </Container>
            </Modal>
        );
    };
}

export default TermsAndConditionsModal;
